(function () {
  'use strict';

  /* @ngdoc object
   * @name deadHeadingReport
   * @description
   *
   */
  angular
    .module('deadHeadingReport', [
      'ui.router'
    ]);
}());
